import React from "react";
import RenderCoBrowsingOffer from "../renderCoBrowsing/renderCoBrowsing";
import ICoBrowseDto from "../../../interface/ICoBrowseDto";
import { CoBrowseContext } from "../../../store/coBrowse.context";
import MessageInput from "../../organisms/chat/messageInput/messageInput";
import MessageList from "../../organisms/chat/messageList/messageList";

const RenderChat = (): React.JSX.Element => {
  const {
    coBrowseDto,
  }: {
    coBrowseDto: ICoBrowseDto;
  } = React.useContext(CoBrowseContext);

  // Function to check if co-browsing is enabled
  // This checks if the sessionJoinToken is not empty or undefined
  // If it is not empty, it indicates that co-browsing is enabled
  // and the co-browsing offer should be rendered
  const isCoBrowsingEnabled = (): boolean => {
    return (
      coBrowseDto.session.sessionJoinToken !== "" &&
      coBrowseDto.session.sessionJoinToken !== undefined
    );
  };

  return (
    <React.Fragment>
      {isCoBrowsingEnabled() && <RenderCoBrowsingOffer />}
      <MessageList />
      <MessageInput />
    </React.Fragment>
  );
};

export default RenderChat;
